import { MapContainer, Marker, TileLayer, useMapEvents } from "react-leaflet";

function Map({
  userLocation,
  setUserLocation,
  zoneCouverte,
  setLatitude,
  setLongitude,
  mapCenter,
  mapZoom,
  onMapCenterChange,
  onMapZoomChange,
}) {
  const LocationFinderDummy = () => {
    useMapEvents({
      click(e) {
        const lat = e?.latlng?.lat;
        const lng = e?.latlng?.lng;

        setUserLocation([lat, lng]);
        setLatitude(lat);
        setLongitude(lng);

        // Optionnel: Mettre à jour le centre de la carte quand l'utilisateur clique
        if (onMapCenterChange) {
          onMapCenterChange([lat, lng]);
        }
      },
    });

    return userLocation ? <Marker position={userLocation}></Marker> : null;
  };

  // Déterminer le centre initial et le zoom
  const getInitialCenter = () => {
    if (mapCenter) return mapCenter;
    if (userLocation) return userLocation;
    return [5.342, -4.024]; // Centre d'Abidjan par défaut
  };

  const getInitialZoom = () => {
    if (mapZoom) return mapZoom;
    return userLocation ? 15 : 12;
  };

  // Déterminer les bounds si nécessaire
  const getBounds = () => {
    if (mapCenter || userLocation) return undefined;
    return [
      [5.316667, -4.033333],
      [5.3677654, -3.9596936],
    ];
  };

  return (
    <div>
      <MapContainer
        key={`${getInitialCenter()}-${getInitialZoom()}`}
        className="h-[200px] lg:h-[500px] lg:w-full rounded-lg"
        style={{ zIndex: 0 }}
        center={getInitialCenter()}
        zoom={getInitialZoom()}
        bounds={getBounds()}
        boundsOptions={{ padding: [20, 20] }}
      >
        <LocationFinderDummy />

        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />

        {/* Afficher le marqueur de la position sélectionnée */}
        {userLocation && <Marker position={userLocation}></Marker>}
      </MapContainer>
    </div>
  );
}

export default Map;
